/**
 * Capitalizes the first letter of each word in a string
 * @param str - The string to capitalize
 * @returns The capitalized string
 * @example capitalizeWords("tap room") => "Tap Room"
 * @example capitalizeWords("ballet dance academy") => "Ballet Dance Academy"
 */
export const capitalizeWords = (str: string | undefined | null): string => {
  if (!str) return '';
  
  return str
    .split(' ')
    .map((word) => {
      if (word.length === 0) return word;
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ');
};

